// extracted by mini-css-extract-plugin
module.exports = {"heading":"FAQ_heading__pERB6","grid":"FAQ_grid__Voivg","item":"FAQ_item__zBEMS","itemWrap":"FAQ_itemWrap__2yDE1"};